export default {"src":"/_next/static/media/rent.2642418a.svg","height":217,"width":238};